import Vue from "vue";
import VueRouter from "vue-router";
import brand from "@/brand";

Vue.use(VueRouter);

// Each brand has its own pages under views/<brand>. Pridge only issues
// invoice (i), feedback (f) and lab order (l) QR codes.
const pdentalRoutes = [
  {
    path: "/",
    name: "home",
    component: () => import("@/views/pdental/Home.vue"),
  },
  {
    path: "/i/:CID?/:QID?",
    name: "Invoice",
    component: () => import("@/views/pdental/Invoice.vue"),
  },
  {
    path: "/p/:CID?/:QID?",
    name: "Prescription",
    component: () => import("@/views/pdental/Prescription.vue"),
  },
  {
    path: "/f/:CID?/:QID?",
    name: "Feedback",
    component: () => import("@/views/pdental/Feedback.vue"),
  },
  {
    path: "/l/:CID?/:QID?",
    name: "LabOrder",
    component: () => import("@/views/pdental/LabOrder.vue"),
  },
  {
    path: "/s/:CID?/:QID?",
    name: "StockOrder",
    component: () => import("@/views/pdental/StockOrder.vue"),
  },
  {
    path: "/t/:CID?/:QID?",
    name: "TreatmentPlan",
    component: () => import("@/views/pdental/TreatmentPlan.vue"),
  },
  {
    path: "/success",
    name: "Success",
    component: () => import("@/views/pdental/Success.vue"),
  },
];

const pridgeRoutes = [
  {
    path: "/",
    name: "home",
    component: () => import("@/views/pridge/Home.vue"),
  },
  {
    path: "/i/:CID?/:QID?",
    name: "Invoice",
    component: () => import("@/views/pridge/Invoice.vue"),
  },
  {
    path: "/f/:CID?/:QID?",
    name: "Feedback",
    component: () => import("@/views/pridge/Feedback.vue"),
  },
  {
    path: "/l/:CID?/:QID?",
    name: "LabOrder",
    component: () => import("@/views/pridge/LabOrder.vue"),
  },
  {
    path: "/success",
    name: "Success",
    component: () => import("@/views/pridge/Success.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes: brand.isPridge ? pridgeRoutes : pdentalRoutes,
});

export default router;
